/* THREADHEADS: Sort prefetch optimization - Cache for prefetched sort URLs to avoid duplicate fetches */
const prefetchedUrls = new Set();
/* THREADHEADS: Sort prefetch optimization - Prefetch a sort option URL for faster loading */
const prefetchSortUrl = (sortValue, sectionId) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.delete('page');
    const urlString = url.toString();
    if (prefetchedUrls.has(urlString))
        return;
    prefetchedUrls.add(urlString);
    // Use low-priority fetch to prefetch without blocking
    fetch(urlString, { priority: 'low' }).catch(() => {
        // Silently fail - prefetch is just an optimization
        prefetchedUrls.delete(urlString);
    });
};
/* THREADHEADS: Sort prefetch optimization - END */
const mainCollection = () => {
    const customFilterButtons = () => {
        var _a;
        // Handle both custom layouts: with and without layout toggle
        const customFilterButtonContainer = document.querySelector('.facets__floating-filter--custom, .facets__floating-filter--custom-inc-layout-toggle');
        if (customFilterButtonContainer) {
            const facetDrawer = document.querySelector('facet-drawer');
            // Attach sort option listeners when drawer opens
            const attachSortListeners = () => {
                const applyFilterButton = document.querySelector('facet-drawer [is="facet-apply-button"]');
                const sortFilterOptions = document.querySelectorAll('facet-drawer #accordion-sort-by input[type="radio"]');
                sortFilterOptions.forEach((option) => {
                    var _a;
                    // Remove existing listeners to prevent duplicates
                    const newOption = option.cloneNode(true);
                    (_a = option.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(newOption, option);
                    newOption.addEventListener('change', () => {
                        applyFilterButton === null || applyFilterButton === void 0 ? void 0 : applyFilterButton.click();
                    });
                });
            };
            // Listen for drawer open event to attach sort listeners
            facetDrawer === null || facetDrawer === void 0 ? void 0 : facetDrawer.addEventListener('dialog:after-show', () => {
                if (facetDrawer.classList.contains('facets-drawer--sort')) {
                    attachSortListeners();
                }
            });
            // Handle sort dropdown options directly (for the new Sort by popover)
            const sortDropdownOptions = document.querySelectorAll('.th-sort-option');
            /* THREADHEADS: Sort prefetch optimization - Prefetch on hover for faster sort response */
            const sortDropdownButton = document.querySelector('.th-sort-by-dropdown__button');
            const sectionId = ((_a = customFilterButtonContainer.closest('.shopify-section')) === null || _a === void 0 ? void 0 : _a.id.replace('shopify-section-', '')) || '';
            // Prefetch all sort options when dropdown button is hovered (with delay to avoid unnecessary fetches)
            let prefetchTimeout = null;
            sortDropdownButton === null || sortDropdownButton === void 0 ? void 0 : sortDropdownButton.addEventListener('mouseenter', () => {
                prefetchTimeout = setTimeout(() => {
                    sortDropdownOptions.forEach((option) => {
                        const sortValue = option.getAttribute('data-sort-value');
                        if (sortValue && sortValue !== new URL(window.location.href).searchParams.get('sort_by')) {
                            prefetchSortUrl(sortValue, sectionId);
                        }
                    });
                }, 100); // Small delay to ensure user intent
            });
            sortDropdownButton === null || sortDropdownButton === void 0 ? void 0 : sortDropdownButton.addEventListener('mouseleave', () => {
                if (prefetchTimeout) {
                    clearTimeout(prefetchTimeout);
                    prefetchTimeout = null;
                }
            });
            // Also prefetch individual option on hover for even faster response
            sortDropdownOptions.forEach((option) => {
                option.addEventListener('mouseenter', () => {
                    const sortValue = option.getAttribute('data-sort-value');
                    if (sortValue) {
                        prefetchSortUrl(sortValue, sectionId);
                    }
                });
            });
            /* THREADHEADS: Sort prefetch optimization - END */
            sortDropdownOptions.forEach((option) => {
                option.addEventListener('click', () => {
                    var _a;
                    const sortValue = option.getAttribute('data-sort-value');
                    if (sortValue) {
                        const url = new URL(window.location.href);
                        url.searchParams.set('sort_by', sortValue);
                        /* THREADHEADS: Mobile fix - Use pre-captured sectionId since popover moves to body on mobile */
                        if (sectionId) {
                            url.searchParams.set('section_id', sectionId);
                        }
                        url.searchParams.delete('page');
                        /* THREADHEADS: Optimistic UI - Update button label immediately before fetch completes */
                        const buttonLabel = sortDropdownButton === null || sortDropdownButton === void 0 ? void 0 : sortDropdownButton.querySelector('.th-sort-by-dropdown__label');
                        const optionText = (_a = option.querySelector('.reversed-link')) === null || _a === void 0 ? void 0 : _a.textContent;
                        if (buttonLabel && optionText) {
                            buttonLabel.textContent = optionText;
                        }
                        // Update aria-selected state optimistically
                        sortDropdownOptions.forEach((opt) => opt.removeAttribute('aria-selected'));
                        option.setAttribute('aria-selected', 'true');
                        /* THREADHEADS: Optimistic UI - END */
                        // Dispatch facet:update event to trigger collection reload
                        document.dispatchEvent(new CustomEvent('facet:update', {
                            bubbles: true,
                            detail: { url },
                        }));
                    }
                });
            });
            // Filter button - always opens the filter drawer
            const filterButton = customFilterButtonContainer.querySelector('.button.button--xl:first-child');
            if (filterButton) {
                filterButton.addEventListener('click', () => {
                    facetDrawer.setAttribute('open-from', 'left');
                    facetDrawer.classList.remove('facets-drawer--sort');
                    facetDrawer.classList.add('facets-drawer--filter');
                    facetDrawer.classList.add('drawer--full-page');
                    const header = facetDrawer.querySelector('[slot="header"]');
                    header.innerHTML = 'Filter';
                });
            }
            // Sort button - only exists when layout toggle is NOT enabled (old layout)
            const sortButton = customFilterButtonContainer.querySelector('.button.button--xl:nth-child(2)');
            if (sortButton) {
                sortButton.addEventListener('click', () => {
                    facetDrawer.setAttribute('open-from', 'bottom');
                    facetDrawer.classList.remove('drawer--full-page');
                    facetDrawer.classList.remove('facets-drawer--filter');
                    facetDrawer.classList.add('facets-drawer--sort');
                    const sortAccordion = facetDrawer.querySelector('[id="accordion-sort-by"]');
                    if (sortAccordion) {
                        sortAccordion.setAttribute('open', '');
                        sortAccordion.setAttribute('aria-expanded', 'true');
                    }
                    const header = facetDrawer.querySelector('[slot="header"]');
                    header.innerHTML = 'Sort by';
                });
            }
        }
    };
    customFilterButtons();
    const collectionLayoutToggles = () => {
        const mainCollectionSection = document.querySelectorAll('.shopify-section--main-collection');
        if (mainCollectionSection) {
            mainCollectionSection.forEach((section) => {
                const layoutToggles = section.querySelectorAll('[data-collection-layout-toggle]');
                if (layoutToggles) {
                    layoutToggles.forEach((toggle) => {
                        toggle.addEventListener('click', () => {
                            const layout = toggle.getAttribute('data-collection-layout-toggle');
                            if (layout != 'multi') {
                                section.classList.add('toggle-single-column');
                            }
                            else {
                                section.classList.remove('toggle-single-column');
                            }
                        });
                    });
                }
            });
        }
    };
    collectionLayoutToggles();
    window.addEventListener('th:facet:update:complete', () => {
        customFilterButtons();
        collectionLayoutToggles();
    });
};
export { mainCollection };
